import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './app/store';
import App from './App';
import './index.css';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import NotificationContextProvider from './context/Notification/NotificationContextProvider';
import { AnimatePresence } from 'framer-motion';
import StripeCheckout from './features/Cart/Stripe/StripeCheckout'
import OrderProcess from './features/Cart/Stripe/OrderProcess';

//Pages Import
import { Home, LoginPage, SignupPage, CartPage, ProductViewPage, CheckoutPage, OrderStatusPage, UserAccountPage, ForgotPasswordPage, OrderPage, AboutPage } from './Pages/exportPages';

//protected Route
import ProtectedRoute from './features/Protected/ProtectedRoute';
import PageNotFound from './Pages/PageNotFound';
import Logout from './features/Auth/components/Logout';
import QueryPage from './Pages/QueryPage';



const container = document.getElementById('root');
const root = createRoot(container);

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: "/",
        element: <Home />
      },
      {
        path: "/about",
        element: <AboutPage />
      },
      {
        path: "/search",
        element: <QueryPage />
      },
      {
        path: "/login",
        element: <LoginPage />
      },
      {
        path: "/register",
        element: <SignupPage />
      },
      {
        path: "/forgot-password",
        element: <ForgotPasswordPage />
      },
      {
        path: "/signout",
        "element": <ProtectedRoute> <Logout /> </ProtectedRoute> //Same compo use effect will catch the url
      },
      {
        path: "/cart",
        element: <ProtectedRoute> <CartPage /> </ProtectedRoute>
      },
      {
        path: "/:href/:pid",
        element: <ProductViewPage />
      },
      {
        path: "checkout",
        "element": <ProtectedRoute> <CheckoutPage /> </ProtectedRoute>
      },
      {
        path: "stripe-checkout",
        "element": <ProtectedRoute> <StripeCheckout /> </ProtectedRoute>
      },
      {
        path: "/order-process",
        element: <ProtectedRoute> <OrderProcess /> </ProtectedRoute>
      },
      {
        path: "order/*",
        "element": <ProtectedRoute> <OrderStatusPage /></ProtectedRoute>
      },
      {
        path: "account",
        "element": <ProtectedRoute> <UserAccountPage /> </ProtectedRoute>
      },
      {
        path: "account/orders",
        "element": <ProtectedRoute> <UserAccountPage /> </ProtectedRoute>  //Same compo use effect will catch the url
      },
      {
        path: "account/orders/:id",
        "element": <ProtectedRoute> <OrderPage /> </ProtectedRoute>  //Same compo use effect will catch the url
      },
      {
        path: "account/addresses",
        "element": <ProtectedRoute> <UserAccountPage /> </ProtectedRoute> //Same compo use effect will catch the url
      },
      {
        path: "account/reviews",
        "element": <ProtectedRoute> <UserAccountPage /> </ProtectedRoute> //Same compo use effect will catch the url
      },
      {
        path: "account/wishlist",
        "element": <ProtectedRoute> <UserAccountPage /> </ProtectedRoute> //Same compo use effect will catch the url
      },
      {
        path: "*",
        "element": <PageNotFound />
      }
    ]
  }
])


root.render(
  <StrictMode>
    <Provider store={store}>
      <NotificationContextProvider>
        <AnimatePresence mode='wait'>
          <RouterProvider router={router} />
        </AnimatePresence>
      </NotificationContextProvider>
    </Provider>
  </StrictMode>
);

